module.exports = __webpack_public_path__ + "img/9788954430326.0f64aa38.jpg";